/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import jwt from '../http/requests/auth/jwt/index.js'
import account from '../http/requests/auth/account/index.js'
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////


  switchPlan({ commit }, {plan_id}) {
    return new Promise((resolve, reject) => {
      jwt
        .updateUserPlan(plan_id)
        .then(response => {
          if (response.data.data) {
          commit('UPDATE_USER_INFO', response.data.data)
          resolve(response)
          }else{
            reject(response.data.error)
          }
            
          
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateGeneralUserInfo({ commit }, {first, last, phone}) {
    return new Promise((resolve, reject) => {
      jwt.
        updateUserinfo(first, last, phone)
        .then(response => {
          if (response.data.message == "Info updated successfully.") {
            commit('UPDATE_USER_INFO',{'firstname': first, 'lastname': last, 'phone': phone})
            resolve(response)
          } else {
            reject(response.data.error)
          }
        }).catch(error => {
          reject(error);
        })
    });
  },


  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
        jwt
          .getUserSummary()
          .then(response => {
          if (response.data.data) {
            commit('UPDATE_USER_INFO', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        }).catch(error => {
          reject(error);
        })
    });

  },

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  updateUserRole ({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', {userRole: payload.userRole})
  },

  enableTwoFactorAuth({ commit }, code) {
    return new Promise((resolve, reject) => {
      jwt
        .enableTwoFactorAuth(code)
        .then(response => {
          if (response.data.status == 0) {
            commit('UPDATE_USER_INFO', {'two_factor_auth': true})
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  disableTwoFactorAuth({ commit }, code) {
  return new Promise((resolve, reject) => {
    jwt
      .disableTwoFactorAuth(code)
      .then(response => {
          if (response.data.status == 0) {
            commit('UPDATE_USER_INFO', {'two_factor_auth': false})
            resolve(response)
          } else {
            reject(response.data.error)
          }
      })
      .catch(error => {
        reject(error)
      })
  })
},

  getAPIKey({ commit }) {
  return new Promise((resolve, reject) => {
    account
      .getApiKey()
      .then(response => {
          if (response.data.status == 0) {
            commit('SET_API_KEY', response.data.data.key)
            resolve(response)
          } else {
            reject(response.data.error)
          }
      })
      .catch(error => {
        reject(error)
      })
  })
},
generateAPIKey({ commit }) {
return new Promise((resolve, reject) => {
  account
    .generateApiKey()
    .then(response => {
        if (response.data.status == 0) {
          commit('SET_API_KEY', response.data.data.key)
          resolve(response)
        } else {
          reject(response.data.error)
        }
    })
    .catch(error => {
      reject(error)
    })
})
},

}

export default actions
